import React from 'react'
import { CreditCard } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminPolicies = () => {
  return (
    <GenericTable
      tableName="policies"
      title="Policies"
      icon={CreditCard}
      iconColor="green"
      searchFields={['policy_number', 'policy_status', 'policy_holder_name', 'premium_amount']}
      hiddenFields={['policy_id', 'created_at', 'updated_at']}
      primaryKey="policy_id"
      defaultFields={['policy_number', 'policy_name', 'policy_status', 'premium_amount', 'sum_insured', 'policy_holder_name', 'policy_start_date', 'policy_end_date']}
      addFields={['customer_id', 'policy_type_id', 'premium_amount', 'sum_insured', 'policy_start_date', 'policy_end_date', 'premium_frequency', 'policy_holder_name', 'policy_holder_relationship']}
      editFields={[
        'policy_status', 'premium_amount', 'sum_insured', 'policy_start_date', 'policy_end_date',
        'premium_frequency', 'policy_holder_name', 'policy_holder_relationship',
        'policy_description', 'deductible_amount', 'co_payment_percentage', 'next_renewal_date', 'grace_period_days',
        'annual_premium', 'total_premium_amount', 'premium_amount', 'last_renewal_date'
        // Excluded: policy_id, policy_number, created_at, updated_at
      ]}
    />
  )
}

export default AdminPolicies